export const features = {
    testResiliency: process.env.REACT_APP_FEATURE_TEST_RESILIENCY === 'true',
};